// extracted by mini-css-extract-plugin
export var wrapper = "about-module--wrapper--1M7g-";
export var image = "about-module--image--2Rk9o";
export var text = "about-module--text--3W7GB";